export const transactionLaneConstants = {
  GET_TRANSACTION_LANE_IN_RTD_SUCCESS: "GET_TRANSACTION_LANE_IN_RTD_SUCCESS",
  GET_TRANSACTION_LANE_IN_RTD_FAILURE: "GET_TRANSACTION_LANE_IN_RTD_FAILURE",
  GET_TRANSACTION_LANE_IN_RTD_LOADING: "GET_TRANSACTION_LANE_IN_RTD_LOADING",

  GET_INDIVIDUAL_TRANSACTION_LOADING:"GET_INDIVIDUAL_TRANSACTION_LOADING",
  GET_INDIVIDUAL_TRANSACTION_SUCCESS: "GET_INDIVIDUAL_TRANSACTION_SUCCESS",
  GET_INDIVIDUAL_TRANSACTION_FAILURE: "GET_INDIVIDUAL_TRANSACTION_FAILURE",
  TRIGGER_INDIVIDUAL_TRANSACTION_FETCH: "TRIGGER_INDIVIDUAL_TRANSACTION_FETCH",


  // Email action Type
  SEND_EMAIL_LOADING: "SEND_EMAIL_LOADING",
  SEND_EMAIL_SUCCESS: "SEND_EMAIL_SUCCESS",
  SEND_EMAIL_FAILURE: "SEND_EMAIL_FAILURE",


  UPLOAD_DOCUMENT_PDF_LOADER: "UPLOAD_DOCUMENT_PDF_LOADER",
  UPLOAD_DOCUMENT_PDF_SUCCESS: "UPLOAD_DOCUMENT_PDF_SUCCESS",

  // GET_DORA_DOCUMENTS_LOADING
  GET_DORA_DOCUMENTS_LOADING: "GET_DORA_DOCUMENTS_LOADING",
  GET_DORA_DOCUMENTS_SUCCESS: "GET_DORA_DOCUMENTS_SUCCESS",
  GET_DORA_DOCUMENTS_FAILURE: "GET_DORA_DOCUMENTS_FAILURE",

  GET_EMAIL_TEMPLATE_LOADING: "GET_EMAIL_TEMPLATE_LOADING",
  GET_EMAIL_TEMPLATE_SUCCESS: "GET_EMAIL_TEMPLATE_SUCCESS",
  GET_EMAIL_TEMPLATE_FAILURE: "GET_EMAIL_TEMPLATE_FAILURE",

  DORADOCS_SHORTHAND_URL_LOADING: "DORADOCS_SHORTHAND_URL_LOADING",
  DORADOCS_SHORTHAND_URL_SUCCESS: "DORADOCS_SHORTHAND_URL_SUCCESS",
  DORADOCS_SHORTHAND_URL_FAILURE: "DORADOCS_SHORTHAND_URL_FAILURE",

  UPDATE_EMAIL_FAILURE:"UPDATE_EMAIL_FAILURE",
  UPDATE_EMAIL_SUCCESS:"UPDATE_EMAIL_SUCCESS",

  CLIENT_DETAILS_LOADING:"CLIENT_DETAILS_LOADING",
  CLIENT_DETAILS_FAILURE:"CLIENT_DETAILS_FAILURE",
  CLIENT_DETAILS_SUCCESS:"CLIENT_DETAILS_SUCCESS",

  CLIENT_LIST_LOADING:"CLIENT_LIST_LOADING",
  CLIENT_LIST_FAILURE:"CLIENT_LIST_FAILURE",
  CLIENT_LIST_SUCCESS:"CLIENT_LIST_SUCCESS",

  ADD_TRANSACTION_MAIL_LOADING:"ADD_TRANSACTION_MAIL_LOADING",
  ADD_TRANSACTION_MAIL_FAILURE:"ADD_TRANSACTION_MAIL_FAILURE",
  ADD_TRANSACTION_MAIL_SUCCESS: "ADD_TRANSACTION_MAIL_SUCCESS",
  
  GET_SHARED_DOCS_LOADING: "GET_SHARED_DOCS_LOADING",
  GET_SHARED_DOCS_SUCCESS: "GET_SHARED_DOCS_SUCCESS",
  GET_SHARED_DOCS_FAILURE: "GET_SHARED_DOCS_FAILURE",

  ADD_EMAIL_LOADING: "ADD_EMAIL_LOADING",
  ADD_EMAIL_ERROR: "ADD_EMAIL_ERROR",
  ADD_EMAIL_SUCCESS: "ADD_EMAIL_SUCCESS",

  GET_CLIENT_DOC_LOADING:"GET_CLIENT_DOC_LOADING",
  GET_CLIENT_DOC_SUCCESS:"GET_CLIENT_DOC_SUCCESS",
  GET_CLIENT_DOC_ERROR:"GET_CLIENT_DOC_ERROR",

  GET_PROPERTY_DOC_WITHOUT_SECTION_LOADING:"GET_PROPERTY_DOC_WITHOUT_SECTION_LOADING",
  GET_PROPERTY_DOC_WITHOUT_SECTION_SUCCESS:"GET_PROPERTY_DOC_WITHOUT_SECTION_SUCCESS",
  GET_PROPERTY_DOC_WITHOUT_SECTION_ERROR:"GET_PROPERTY_DOC_WITHOUT_SECTION_ERROR",

  CLIENT_PORTAL_LOADING: "CLIENT_PORTAL_LOADING",
  CLIENT_PORTAL_ERROR: "CLIENT_PORTAL_ERROR",
  CLIENT_PORTAL_SUCCESS: "CLIENT_PORTAL_SUCCESS",

  GENERATE_DASHBOARD_LINK_LOADING: "GENERATE_DASHBOARD_LINK_LOADING",
  GENERATE_DASHBOARD_LINK_SUCCESS: "GENERATE_DASHBOARD_LINK_SUCCESS",
  GENERATE_DASHBOARD_LINK_ERROR: "GENERATE_DASHBOARD_LINK_ERROR",
  
  EMAIL_FILES_LOADING: " EMAIL_FILES_LOADING",
  EMAIL_FILES_ERROR: " EMAIL_FILES_ERROR",
  EMAIL_FILES_SUCCESS: " EMAIL_FILES_SUCCESS",

  RESET_FOLDER_OPEN_STATE: "RESET_FOLDER_OPEN_STATE",
  TOGGLE_FOLDER_OPEN_STATE: "TOGGLE_FOLDER_OPEN_STATE",

  UPLOAD_DOCUMENT_LOADING: "UPLOAD_DOCUMENT_LOADING",
  UPLOAD_DOCUMENT_SUCCESS: "UPLOAD_DOCUMENT_SUCCESS",
  UPLOAD_DOCUMENT_FAILURE: "UPLOAD_DOCUMENT_FAILURE",

  TRIGGER_GET_PERSON_DOCS: "TRIGGER_GET_PERSON_DOCS",

  GET_MOVE_TO_FOLDER_DATA_LOADING: "GET_MOVE_TO_FOLDER_DATA_LOADING",
  GET_MOVE_TO_FOLDER_DATA_SUCCESS: "GET_MOVE_TO_FOLDER_DATA_SUCCESS",
  GET_MOVE_TO_FOLDER_DATA_ERROR: "GET_MOVE_TO_FOLDER_DATA_ERROR",

  DOWNLOAD_ALL_FILES_AS_ZIP_REQUEST_LOADING: "DOWNLOAD_ALL_FILES_AS_ZIP_REQUEST_LOADING",
  DOWNLOAD_ALL_FILES_AS_ZIP_REQUEST_SUCCESS: "DOWNLOAD_ALL_FILES_AS_ZIP_REQUEST_SUCCESS",

  GET_TEMPLATE_DOC_SET_LOADING: "GET_TEMPLATE_DOC_SET_LOADING",
  GET_TEMPLATE_DOC_SET_ERROR: "GET_TEMPLATE_DOC_SET_ERROR",
  GET_TEMPLATE_DOC_SET_SUCCESS: "GET_TEMPLATE_DOC_SET_SUCCESS",
  RESET_TEMPLATE_DOC_SET: "RESET_TEMPLATE_DOC_SET",

  GET_PRE_DORA_DOCUMENTS_LOADING:"GET_PRE_DORA_DOCUMENTS_LOADING",
     GET_PRE_DORA_DOCUMENTS_SUCCESS:"GET_PRE_DORA_DOCUMENTS_SUCCESS",
     GET_PRE_DORA_DOCUMENTS_FAILURE:"GET_PRE_DORA_DOCUMENTS_FAILURE",

  TRIGGER_TRANSACTION_LANE_API: "TRIGGER_TRANSACTION_LANE_API",

  GET_RESURE_SIGN_DOC_LOADING:"GET_RESURE_SIGN_DOC_LOADING",
     GET_RESURE_SIGN_DOC_SUCCESS:"GET_RESURE_SIGN_DOC_SUCCESS",
     GET_RESURE_SIGN_DOC_ERROR:"GET_RESURE_SIGN_DOC_ERROR",

     IMPORT_RESURE_SIGN_DOC_SUCCESS:"IMPORT_RESURE_SIGN_DOC_SUCCESS",

};
